import { GetServerSidePropsContext, GetServerSidePropsResult } from 'next';
import LegalDocumentView from '@/website/components/legalDocument';
import { LegalPageProps, getLegalPageProps } from '@/website/util/legal';

const SLUG = 'contact-us';

export async function getServerSideProps(context: GetServerSidePropsContext): Promise<GetServerSidePropsResult<LegalPageProps>> {
  return getLegalPageProps(context, SLUG);
}

export default function ContactUsPage(props: LegalPageProps): JSX.Element {
  return <LegalDocumentView post={props.post} documentVersions={props.documentVersions} />;
}
